import {
  SET_NOTIFICATION_DRAWER_OPEN_REQUESTED,
  SET_NOTIFICATION_DRAWER_OPEN_COMPLETED,
} from './types';

const setAction = (isOpen) => (dispatch) => {
  dispatch({
    type: SET_NOTIFICATION_DRAWER_OPEN_REQUESTED,
  });

  return dispatch({
    type: SET_NOTIFICATION_DRAWER_OPEN_COMPLETED,
    payload: isOpen,
  });
};

export default setAction;
